const install = (Vue, vm) => {
	// 请求拦截器
	uni.$u.http.interceptors.request.use((config) => {
		const Headtoken = vm.$store.state.token
		// 判断有无token，有则加入请求头中
		if (Headtoken) {
			config.header['token'] = Headtoken;
		}
		return config;
	}, config => {
		return Promise.reject(config)
	})
	
	// 响应拦截器
	uni.$u.http.interceptors.response.use((response) => {
		console.log(response.data.code)
		if (response.data.code === 5113) {
			uni.navigateTo({
				url: '/pages/login/login'
			});
			return
		}
		if (response.data.code !== 200) {
			uni.showToast({
				title: response.data.message,
				icon: "none",
				duration: 2000
			});
			return response.data
		}
		return response.data
	}, (response) => {
		return Promise.reject(response)
	})
}

export default { install }